/*@ngInject*/
const BackupRepository = function (baseRepository, temporaryLoginTokenRepository) {

    angular.extend(this, baseRepository);

    this.backup = function(sectionName) {
        var url = '/database/DatabaseDownloadServlet',
            config = {
                params: {
                    sectionName: sectionName
                }
            };

        return temporaryLoginTokenRepository.getSingleUseToken().then((token) => {
            config.params.t = token;
            return this.get(url, config);
        });
    };

};
angular.module('ums.configuration')
    .service('backupRepository', BackupRepository);
